// extracted by mini-css-extract-plugin
export default {"overlay":"PhotoFullscreenModal_overlay__7OcFV modal-overlay-enter","image":"PhotoFullscreenModal_image__yrq3l modal-panel-enter","closeBtn":"PhotoFullscreenModal_closeBtn__SJUVL"};